module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects.json
// module id = 328
// module chunks = 97786326051841